import React from "react";

interface CustomCardProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void; // Add onClick prop
}

const CustomCard: React.FC<CustomCardProps> = ({
  children,
  className = "",
  onClick, // Destructure onClick
}) => (
  <div
    className={`custom-card-base ${className}`}
    onClick={onClick} // Attach onClick handler
    role={onClick ? "button" : undefined} // Add accessibility
    tabIndex={onClick ? 0 : undefined} // Make focusable if clickable
  >
    {children}
  </div>
);

export default CustomCard;
